import { EventsItems, InsightsClient } from 'algoliasearch'
import client from '.'

// Insightsクライアントの初期化
let insights: InsightsClient

const getInsights = () => {
  if (typeof window === 'undefined') {
    return null
  }
  if (!insights) {
    insights = client.initInsights({
      appId: process.env.ALGOLIA_APP_ID || '',
      apiKey: process.env.ALGOLIA_KEY || '',
      region: 'us',
    })
  }
  return insights
}

export const trackSoundPlay = ({
  userId,
  soundId,
  albumId,
  creatorId,
}: {
  userId: string,
  soundId?: string,
  albumId?: string,
  creatorId?: string,
}) => {
  if (!soundId) {
    return
  }
  const events: EventsItems[] = [{
    eventName: 'sound_played',
    eventType: 'conversion',
    userToken: userId ? `user-${userId}` : 'anonymous',
    authenticatedUserToken: userId && `user-${userId}`,
    index: 'media',
    objectIDs: [ `sound-${soundId}` ],
  }]
  if (albumId) {
    events.push({
      eventName: 'album_played',
      eventType: 'conversion',
      userToken: userId ? `user-${userId}` : 'anonymous',
      authenticatedUserToken: userId && `user-${userId}`,
      index: 'media',
      objectIDs: [ `album-${albumId}` ],
    })
  }
  if (creatorId) {
    events.push({
      eventName: 'creator_played',
      eventType: 'conversion',
      userToken: userId ? `user-${userId}` : 'anonymous',
      authenticatedUserToken: userId && `user-${userId}`,
      index: 'users',
      objectIDs: [ `user-${creatorId}` ],
    })
  }
  try {
    getInsights()?.pushEvents({ events })
  }
  catch (error) {
    console.error('Error pushing sound play events:', error)
  }
}

export const trackSoundView = ({
  userId,
  soundId,
}: {
  userId: string,
  soundId?: string,
}) => {
  if (!soundId) {
    return
  }
  try {
    getInsights()?.pushEvents({
      events: [{
        eventName: 'sound_viewed',
        eventType: 'view',
        userToken: userId ? `user-${userId}` : 'anonymous',
        authenticatedUserToken: userId && `user-${userId}`,
        index: 'media',
        objectIDs: [ `sound-${soundId}` ],
      }],
    })
  }
  catch (error) {
    console.error('Error pushing sound view event:', error)
  }
}

export const trackAlbumView = ({
  userId,
  albumId,
}: {
  userId: string,
  albumId?: string,
}) => {
  if (!albumId) {
    return
  }
  try {
    getInsights()?.pushEvents({
      events: [{
        eventName: 'album_viewed',
        eventType: 'view',
        userToken: userId ? `user-${userId}` : 'anonymous',
        authenticatedUserToken: userId && `user-${userId}`,
        index: 'media',
        objectIDs: [ `album-${albumId}` ],
      }],
    })
  }
  catch (error) {
    console.error('Error pushing album view event:', error)
  }
}

export const trackUserView = ({
  userId,
  viewedUserId,
}: {
  userId: string,
  viewedUserId: string,
}) => {
  if (!userId) {
    return
  }
  try {
    getInsights()?.pushEvents({
      events: [{
        eventName: 'user_viewed',
        eventType: 'view',
        userToken: userId ? `user-${userId}` : 'anonymous',
        authenticatedUserToken: userId && `user-${userId}`,
        index: 'users',
        objectIDs: [ `user-${viewedUserId}` ],
      }],
    })
  }
  catch (error) {
    console.error('Error pushing user view event:', error)
  }
}

export const trackSoundPurchased = ({
  userId,
  soundId,
}:{
  userId?: string,
  soundId?: string,
}) => {
  if (!soundId) {
    return
  }
  try {
    getInsights()?.pushEvents({
      events: [{
        eventName: 'sound_purchased',
        eventType: 'conversion',
        eventSubtype: 'purchase',
        userToken: userId ? `user-${userId}` : 'anonymous',
        authenticatedUserToken: userId && `user-${userId}`,
        index: 'media',
        objectIDs: [ `sound-${soundId}` ],
      }],
    })
  }
  catch (error) {
    console.error('Error pushing sound purchase event:', error)
  }
}

export const trackAlbumPurchased = ({
  userId,
  albumId,
}:{
  userId?: string,
  albumId?: string,
}) => {
  if (!albumId) {
    return
  }
  try {
    getInsights()?.pushEvents({
      events: [{
        eventName: 'album_purchased',
        eventType: 'conversion',
        eventSubtype: 'purchase',
        userToken: userId ? `user-${userId}` : 'anonymous',
        authenticatedUserToken: userId && `user-${userId}`,
        index: 'media',
        objectIDs: [ `album-${albumId}` ],
      }],
    })
  }
  catch (error) {
    console.error('Error pushing album purchase event:', error)
  }
}
